module.exports = __webpack_public_path__ + "static/028-691ecf5bba45787c68456f859b35f4af.jpg";